module.exports = __webpack_public_path__ + "assets/img/00036.bac55b53.png";